<template>
  <div>
    <newapikey :customerId="getCurrentCustomerId" />
  </div>
</template>
<script>
import newapikey from "../../components/customers/newapikey";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", ["currentUser", "currentUser"]),
    getCurrentCustomerId() {
      const key = this.currentUser.user?.customerCurrent?.customerId ?? 0;
      return key;
    },
  },
  components: {
    newapikey,
  },
};
</script>
